<app-dialog class="save-consumption-generation-dialog">
  <ng-container dialog-title>
    <h4 class="header">Straßenbeleuchtung</h4>
  </ng-container>
  <ng-container dialog-content>
    <div class="dashboard-icons">
      <app-dashboard-panel
        *ngIf="!!authService.permissions.SOCKET_SERVICE"
        (click)="closeModal('Storungmelden')"
        title="{{ 'module.modals.streetLighting.failureReportTitleDashboardLinkText' | translate }}"
        hoverSrc="./assets/icons/Storungmelden_hover.svg"
        src="./assets/icons/Storungmelden.svg"
        [routerLink]="['/', 'strassenbeleuchtung.schaeden']"
      ></app-dashboard-panel>
      <app-dashboard-panel
        *ngIf="!!authService.permissions.STREETLIGHT_PLANNER"
        (click)="closeModal('Strabenbeleuchtungplanen')"
        [routerLink]="['/', 'energiekarte']"
        [queryParams]="{ salesTool: 'true' }"
        class="lokaler-strommarkt"
        title="{{ 'module.modals.streetLighting.streetLightingPlannersTitleDashBoardLinkText' | translate }}"
        hoverSrc="./assets/icons/Strabenbeleuchtungplanen_hover.svg"
        src="./assets/icons/Strabenbeleuchtungplanen.svg"
      >
      </app-dashboard-panel>
      <app-dashboard-panel
        class="lokaler-strommarkt"
        title="{{ 'module.streetLightWidgets.downloadStreetLights' | translate }}"
        (click)="downloadStreetlights('Brennstellenliste')"
        hoverSrc="./assets/icons/Brennstellenliste_hover.svg"
        src="./assets/icons/Brennstellenliste.svg"
      >
      </app-dashboard-panel>
      <app-dashboard-panel
        *ngIf="!!authService.permissions.SERVICE_REPORT"
        class="lokaler-strommarkt"
        (click)="closeModal('ServiceReport')"
        title="{{ 'module.streetLightWidgets.serviceReportIcon' | translate }}"
        hoverSrc="./assets/icons/Inspektionsbericht_hover.svg"
        src="./assets/icons/Inspektionsbericht.svg"
      >
      </app-dashboard-panel>
      <app-dashboard-panel
        *ngIf="!!authService.permissions.PRODUCT_CATALOGUE"
        class="lokaler-strommarkt"
        title="{{ 'module.streetLightWidgets.productCatalogueIcon' | translate }}"
        hoverSrc="./assets/icons/Produktkatalog_hover.svg"
        src="./assets/icons/Produktkatalog.svg"
        (click)="closeModal('Produktkatalog')"
        [routerLink]="['/', 'produktkatalog']"
      >
      </app-dashboard-panel>
    </div>
  </ng-container>
</app-dialog>
